var render = function render(){var _vm=this,_c=_vm._self._c;return _c('field-string',_vm._b({attrs:{"rules":_vm.iRules,"type":"number"},model:{value:(_vm.iValue),callback:function ($$v) {_vm.iValue=$$v},expression:"iValue"}},'field-string',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }